import { Link, useLocation } from "react-router-dom";
import { Home, Music4, Users, Clapperboard, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/sing", label: "Sing", icon: Music4 },
  { to: "/community", label: "Community", icon: Users },
  { to: "/clips", label: "Clips", icon: Clapperboard },
  { to: "/profile", label: "Profile", icon: User },
];

const MobileTabs = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || !user.user_id) return null;
  return (
    <nav
      className="fixed bottom-3 left-1/2 z-50 flex -translate-x-1/2 items-center gap-1 rounded-full border border-[#E2DDD0] bg-white/90 px-2 py-2 shadow-xl backdrop-blur-xl lg:hidden"
      data-testid="mobile-tabs"
    >
      {TABS.map((t) => {
        const active = pathname === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`mobile-tab-${t.label.toLowerCase()}`}
            className={`flex flex-col items-center gap-0.5 rounded-full px-3.5 py-1.5 transition-colors ${
              active ? "bg-slate-900 text-white" : "text-slate-500"
            }`}
          >
            <t.icon className="h-[18px] w-[18px]" />
            <span className="text-[10px] font-bold">{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileTabs;
